// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"spinner-module__spinnerContainer___2y5lM","spinner":"spinner-module__spinner___uFaC0"};